import type { Invoice, InvoiceItem } from "./types";

export function itemTotal(item: InvoiceItem) {
  return safeNumber(item.quantity) * safeNumber(item.unitPrice);
}

export function invoiceTotal(invoice: Invoice) {
  return invoice.items.reduce((sum, item) => sum + itemTotal(item), 0);
}

function safeNumber(value: number) {
  return Number.isFinite(value) ? value : 0;
}
